// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.travel-expenses__btn {\n  width: auto;\n  min-width: 60px;\n  margin-left: auto;\n  padding: 0 5px;\n}\n.travel-expenses--admin .feedback-section__title {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
